import { useDispatch, useSelector } from 'react-redux';
import { orgActions } from '../store/orgSettings';

export const getPermissionModule = (permissionKey, permissions) => {
  return permissions?.find((permission) => {
    if (permission?.key === permissionKey) return true;
    return permission?.submodules?.includes(permissionKey);
  });
};

export const hasPermissionByKey = (permissionKey, permissions) => {
  return Boolean(getPermissionModule(permissionKey, permissions));
};

export const useSubscriptionPermission = (permissionKey) => {
  const { permissions } = useSelector((s) => s.orgSettings);
  const dispatch = useDispatch();

  const permissionModule = getPermissionModule(permissionKey, permissions);
  const hasPermission = hasPermissionByKey(permissionKey, permissions);

  const getPermissions = () => dispatch(orgActions.getPermissions({}));

  return {
    hasPermission,
    getPermissions,
    permissionModule,
    permissions,
  };
};
